import React, { PropTypes } from 'react';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';

const ReportType = (props) => {
  return (
    <FormGroup controlId="reportType">
      <Col componentClass={ControlLabel} sm={2}>
        Report Type
      </Col>
      <Col sm={10}>
            <select
              className="custom-select"
              onChange={props.handleChangeReportType}
              value={props.defaultReportType}>
              <option value="quotation">Quotation</option>
              <option value="coverNote">Cover Note</option>
            </select>
      </Col>
    </FormGroup>
  )
}

ReportType.propTypes = {
  handleChangeReportType: PropTypes.func,
  defaultReportType: PropTypes.string
};

export default ReportType;



// WEBPACK FOOTER //
// ./src/app/components/reportType/ReportType.js